import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', () => {
    const appName = ref('Sky web')

    const httpServer = ref('')
    const wsServer = ref('')

    const UDS_HTTP = ref('https://uds-parser.shatl-t.ru')
    const UDS_WS = ref('wss://uds-parser.shatl-t.ru')

    const imgServer = ref('https://sky-images.its-telematics.ru/')

    const API_version = ref('v2')

    const isMobile = ref(false)

    const leafletConfig = {
        zoom: {
            snap: 1,
            wheel: 600
        }
    }

    return {
        appName,
        httpServer,
        wsServer,
        UDS_HTTP,
        UDS_WS,
        imgServer,
        API_version,
        leafletConfig,
        isMobile
    }
})
